<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'My Players' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-list-search
    [userList]="playerGroups"
    [isGroupSearch]="true"
    (searchResult)="playerGroups = $event"
  ></app-list-search>

  @if(playerGroups?.length){
    <ion-list class="content-width">
        <ion-item-group *ngFor="let pg of playerGroups">
          <ion-item-divider>
            <ion-label>{{ pg.initial }}</ion-label>
          </ion-item-divider>
    
          <ion-item *ngFor="let user of pg.players" [routerLink]="[user._id]">
            <ion-avatar slot="start">
              <img
                *ngIf="user?.profile_image; else defaultAvatar"
                [src]="user.profile_image"
                alt="Profile Image"
              />
            </ion-avatar>
            <ng-template #defaultAvatar>
              <!-- <ion-avatar> -->
              <!-- <ion-icon name="person-circle-outline" size="large"></ion-icon> -->
              <img class="avatarImage" [src]="avatarImage" />
              <!-- </ion-avatar> -->
            </ng-template>
            <ion-label> {{ user.first_name }} {{ user.last_name }} </ion-label>
          </ion-item>
        </ion-item-group>
    </ion-list>
  } @else {
    <app-empty-page
        *ngIf="authUser && !authUser.associated_users.length"
        text="{{'Click on the plus button below to add a player' | translate}}"
        iconName="people"
  ></app-empty-page>
  }

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button color="primary" (click)="addPlayer()">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
